export type LoginMethod = "otp" | "password";

const LABELS: Record<LoginMethod, string> = {
  otp: "Mobile OTP",
  password: "Email & Password",
};

/**
 * Switches between the sign-in methods a tenant offers.
 *
 * Renders nothing when only one method is enabled — a single tab is just noise, and most tenants
 * will only ever have one.
 */
export function LoginMethodTabs({
  methods,
  active,
  onSelect,
  disabled,
}: {
  methods: LoginMethod[];
  active: LoginMethod;
  onSelect: (method: LoginMethod) => void;
  disabled?: boolean;
}) {
  if (methods.length < 2) {
    return null;
  }

  return (
    <div role="group" aria-label="Sign-in method" className="login-method-tabs">
      {methods.map((method) => (
        <button
          key={method}
          type="button"
          aria-pressed={active === method}
          disabled={disabled}
          onClick={() => onSelect(method)}
        >
          {LABELS[method]}
        </button>
      ))}
    </div>
  );
}
